import { render, staticRenderFns } from "./ExtField.vue?vue&type=template&id=38f87c8f&scoped=true&"
import script from "./ExtField.vue?vue&type=script&lang=js&"
export * from "./ExtField.vue?vue&type=script&lang=js&"
import style0 from "./ExtField.vue?vue&type=style&index=0&id=38f87c8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f87c8f",
  null
  
)

export default component.exports